import React, { useState } from 'react'
import { FaUser } from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa";
import Profile from './profile';
import Whatsapp from './whatsapp';
import { FaEnvelope } from "react-icons/fa";
import Emailsetting from './Emailsetting';
import Funds from './funds';
import Products from './Products';
import Seemore from './seemore';
import { FiUserCheck } from "react-icons/fi";
import { RiRefundLine } from "react-icons/ri";
import { FaBox } from "react-icons/fa";
import { TbArrowsSort } from "react-icons/tb";

function User({ username, setusername, filteredUsers, setShowList, showList, selectedUser, setSelectedUser, userdetails, setuserdetail }) {
    const token = localStorage.getItem('token');
    let userId = null;
    if (token) {
        try {
            const payload = token.split('.')[1];
            const payloadDecoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
            userId = payloadDecoded.userId || null;
        } catch (err) { console.error("Failed to decode token:", err); }
    }
    const currentUserId = userId;
    const [activetab, setactive] = useState('profile');

    const accountTypeBadge = (type) => {
        const t = (type || '').toLowerCase();
        const map = {
            reseller: 'bg-purple-100 text-purple-600 border-purple-200',
            manager:  'bg-yellow-100 text-yellow-600 border-yellow-200',
            agent:    'bg-blue-100 text-blue-600 border-blue-200',
            user:     'bg-green-100 text-green-600 border-green-200',
        };
        return map[t] || 'bg-gray-100 text-gray-500 border-gray-200';
    };

    const statusBadge = (status) => {
        return (status || '').toLowerCase() === 'active'
            ? 'bg-green-100 text-green-600 border-green-200'
            : 'bg-red-100 text-red-500 border-red-200';
    };

    return (
        <>
            {/* ── User Table (always visible) ─────────────────────────── */}
            {!userdetails && (
                <div className='overflow-x-auto mt-3'>
                    <table className='w-full border border-[#dee2e6] text-[11px]'>
                        <thead>
                            <tr className='bg-[#f6f9fc] dark:bg-[#1a1f24] text-left'>
                                {['#', 'Name', 'Email', 'Mobile', 'Account Type', 'Status', 'Expiry', 'Wallet', 'Action'].map(col => (
                                    <th key={col} className='p-2 border border-[#dee2e6] text-[#576071] dark:text-white font-semibold'>
                                        <div className='flex items-center justify-between gap-1'>
                                            <span>{col}</span>
                                            {col !== '#' && col !== 'Action' && (
                                                <TbArrowsSort className='text-gray-400' />
                                            )}
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {filteredUsers.length === 0 ? (
                                <tr>
                                    <td colSpan={9} className='py-10 text-center text-gray-400 text-[12px] bg-[#f6f9fc] dark:bg-[#121519]'>
                                        No users found
                                    </td>
                                </tr>
                            ) : (
                                filteredUsers.map((user, i) => (
                                    <tr
                                        key={user.id || i}
                                        className='odd:bg-white even:bg-[#edf1f5] dark:odd:bg-[#121519] dark:even:bg-[#1a1f24] hover:bg-[#e8f0fa] dark:hover:bg-[#2a2f35] transition-colors'
                                    >
                                        <td className='p-2 border border-[#dee2e6] text-gray-400'>{i + 1}</td>
                                        <td className='p-2 border border-[#dee2e6] dark:text-white font-medium'>
                                            {user.name || '-'}
                                        </td>
                                        <td className='p-2 border border-[#dee2e6] text-gray-500 dark:text-gray-300'>
                                            {user.email || '-'}
                                        </td>
                                        <td className='p-2 border border-[#dee2e6] dark:text-white font-mono'>
                                            {user.Mobile || user.mobile || '-'}
                                        </td>
                                        <td className='p-2 border border-[#dee2e6]'>
                                            <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold border capitalize ${accountTypeBadge(user.accountType)}`}>
                                                {user.accountType || 'User'}
                                            </span>
                                        </td>
                                        <td className='p-2 border border-[#dee2e6]'>
                                            <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold border capitalize ${statusBadge(user.status)}`}>
                                                {user.status || 'Inactive'}
                                            </span>
                                        </td>
                                        <td className='p-2 border border-[#dee2e6] text-gray-400 dark:text-gray-300'>
                                            {user.Expiry ? new Date(user.Expiry).toLocaleDateString() : '-'}
                                        </td>
                                        <td className='p-2 border border-[#dee2e6] dark:text-white'>
                                            ₹{parseFloat(user.wallet || 0).toFixed(2)}
                                        </td>
                                        <td className='p-2 border border-[#dee2e6]'>
                                            <button
                                                onClick={() => {
                                                    setSelectedUser(user);
                                                    setuserdetail(true);
                                                    setusername(user.name || '');
                                                    setShowList(false);
                                                }}
                                                className='text-[#3f7fca] text-[10px] font-semibold border border-[#3f7fca] px-2 py-0.5 rounded hover:bg-[#3f7fca] hover:text-white transition-colors'
                                            >
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {/* ── User Detail Panel ───────────────────────────────────── */}
            {userdetails && (
                <>
                    {/* Back button */}
                    <div className='mt-3 mb-1 px-1'>
                        <button
                            onClick={() => {
                                setuserdetail(false);
                                setusername('');
                                setSelectedUser({});
                            }}
                            className='text-[11px] text-[#3f7fca] border border-[#3f7fca] px-3 py-1 rounded hover:bg-[#3f7fca] hover:text-white transition-colors'
                        >
                            ← Back to List
                        </button>
                    </div>

                    <div className='w-full flex flex-wrap gap-2 border-b border-[#cfcdcd] pt-3 pb-3'>
                        {[
                            { key: 'profile',  icon: <FaUser />,       label: 'Profile' },
                            { key: 'Whatsapp', icon: <FaWhatsapp />,    label: 'Whatsapp' },
                            { key: 'Funds',    icon: <RiRefundLine />,  label: 'Funds' },
                            { key: 'Products', icon: <FaBox />,         label: 'Products' },
                            { key: 'Email',    icon: <FaEnvelope />,    label: 'Email Setting' },
                            { key: 'Seemore',  icon: <FiUserCheck />,   label: 'See More' },
                        ].map(({ key, icon, label }) => (
                            <button
                                key={key}
                                onClick={() => setactive(key)}
                                className={`flex items-center text-[12px] font-semibold gap-2 px-2 py-2 ${
                                    activetab === key
                                        ? 'border-b-2 border-[#448c74] text-[#448c74]'
                                        : 'border-b border-transparent text-[#61748f]'
                                }`}
                            >
                                {icon} {label}
                            </button>
                        ))}
                    </div>

                    {activetab === 'profile'  && <Profile id={selectedUser?.id} username={selectedUser?.name} email={selectedUser?.email} days={selectedUser?.days} Expirydate={selectedUser?.Expiry} mobileNumber={selectedUser?.Mobile} password={selectedUser?.password} loginDate={selectedUser?.startDate} accountStatus={selectedUser?.status} accountType={selectedUser?.accountType} apiKey={selectedUser?.API_Key} products={selectedUser?.products} createdAt={selectedUser?.created} />}
                    {activetab === 'Whatsapp' && <Whatsapp client_id={selectedUser?.id} user_id={currentUserId} />}
                    {activetab === 'Funds'    && <Funds client_id={selectedUser?.id} user_id={currentUserId} />}
                    {activetab === 'Email'    && <Emailsetting client_id={selectedUser?.id} user_id={currentUserId} />}
                    {activetab === 'Products' && <Products client_id={selectedUser?.id} user_id={currentUserId} />}
                    {activetab === 'Seemore'  && <Seemore client_email={selectedUser?.email} client_id={selectedUser?.id} user_id={currentUserId} />}
                </>
            )}
        </>
    );
}

export default User;